module.exports = __webpack_public_path__ + "img/chinesecompany137.83a1ea3e.png";